import { useSearchParams } from 'react-router-dom';
import { AppNav } from '@/components/AppNav';
import { useResetPasswordMutation } from '@/generated/graphql';
import { useState } from 'react';
import { toast } from 'sonner';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { LOGIN_ROUTE } from './consts';
import { MIN_PASSWORD_LENGTH } from '@/consts/auth';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return (
    <div className="flex min-h-screen flex-col">
      <AppNav />
      <div
        className={`relative z-[2] mx-auto flex max-w-screen-md flex-1 flex-col items-center justify-center`}
      >
        {token ? <ResetPasswordForm token={token} /> : <div>Invalid token</div>}
      </div>
    </div>
  );
}

function ResetPasswordForm({ token }: { token: string }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [success, setSuccess] = useState(false);

  const [resetPassword, { loading }] = useResetPasswordMutation();

  const handleSubmit = async () => {
    try {
      await resetPassword({ variables: { token, password } });
      toast.success('Password reset successful!');
      setSuccess(true);
    } catch (error: any) {
      toast.error(
        error.graphQLErrors?.[0]?.message || 'Failed to reset password',
      );
    }
  };

  const isValidPassword =
    password === confirmPassword && password.length >= MIN_PASSWORD_LENGTH;

  return (
    <div className="flex flex-col gap-6">
      <Card className="min-w-[300px]">
        <CardHeader>
          <CardTitle>Reset Password</CardTitle>
          <CardDescription>
            {success ? (
              <>
                Password reset successful! <Link to={LOGIN_ROUTE}>Login</Link>
              </>
            ) : (
              'Enter your new password. '
            )}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className={`flex flex-col gap-2 ${success ? 'hidden' : ''}`}>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your new password"
            />
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your new password"
            />
            <div className="flex justify-start gap-2">
              <Button
                onClick={handleSubmit}
                disabled={!isValidPassword || loading}
              >
                {loading ? 'Resetting Password...' : 'Reset Password'}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
